import { Component, Prop, h, Host } from '@stencil/core';

/** The `pn-tag` is a non-interactive visual marker designed to emphasize important aspects of an item, such as its status. */
@Component({
  tag: 'pn-tag',
  styleUrl: 'pn-tag.scss',
})
export class PnTag {
  /** The label of the tag. */
  @Prop() label!: string;
  /**
   * Select icon from out `pn-design-assets` list. Works with any SVG content.
   *
   * **Please note**: Can not be used with the `xsmall` prop due to the small size.
   *
   * @see {@link https://portal.postnord.com/web-components/?path=/docs/docs-assets--docs Get started with PostNord assets.}
   */
  @Prop() icon?: string;
  /** Set tag appearance: `discrete`, `positive`, `warning` & `error`. @category Visual */
  @Prop() appearance?: '' | 'discrete' | 'positive' | 'warning' | 'error' = '';
  /**
   * Set darker background-color on the tag.
   *
   * This is intended for better tag visibility on colored background.
   *
   * @category Visual
   * @deprecated Will be removed in v8.0.0
   */
  @Prop() dark?: boolean = false;
  /** Set larger tag. @category Size */
  @Prop() large?: boolean = false;
  /** Set smaller tag. @category Size */
  @Prop() small?: boolean = false;
  /** Set extra small tag. @category Size */
  @Prop() xsmall?: boolean = false;

  componentWillRender() {
    if (!!this.icon && this.xsmall) console.warn(`pn-tag: Icon was not rendered because tag size is set to xsmall`);
  }

  showIcon() {
    return !!this.icon && !this.xsmall;
  }

  render() {
    return (
      <Host>
        <div
          class="pn-tag"
          data-appearance={this.appearance}
          data-icon={!!this.icon}
          data-dark={this.dark}
          data-small={this.small}
          data-xsmall={this.xsmall}
          data-large={this.large}
        >
          {this.showIcon() && <pn-icon icon={this.icon}></pn-icon>}
          <span class="pn-tag-label">{this.label}</span>
        </div>
      </Host>
    );
  }
}
